import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { FontProvider } from "./contexts/FontContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FontProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </FontProvider>
  </React.StrictMode>
);
